var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"50px"}},[_c('infoList',{attrs:{"orgin":_vm.title,"column_code":_vm.columnCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }